import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const ParallaxContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
`;

const ParallaxElement = styled(motion.div)`
  position: absolute;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.1;
`;

const ParallaxBackground = ({ 
  elements = [
    { image: '/images/bg-2.png', size: 100, top: '20%', left: '10%', rotation: -45, yRange: [0, 20, 0], rotateRange: [-45, -40, -45], delay: 0 },
    { image: '/images/bg-2.png', size: 150, top: '60%', right: '15%', rotation: 45, yRange: [0, -20, 0], rotateRange: [45, 40, 45], delay: 1 },
    { image: '/images/bg-2.png', size: 120, bottom: '20%', left: '20%', rotation: -30, yRange: [0, 15, 0], rotateRange: [-30, -25, -30], delay: 2 },
    { image: '/images/bg-2.png', size: 180, top: '30%', right: '25%', rotation: 30, yRange: [0, -15, 0], rotateRange: [30, 25, 30], delay: 3 },
  ]
}) => {
  return (
    <ParallaxContainer>
      {elements.map((element, index) => (
        <ParallaxElement
          key={index}
          style={{
            width: element.size,
            height: element.size,
            top: element.top,
            left: element.left,
            right: element.right,
            bottom: element.bottom,
            backgroundImage: `url("${element.image}")`,
            transform: `rotate(${element.rotation}deg)`,
          }}
          animate={{
            y: element.yRange,
            rotate: element.rotateRange,
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut",
            delay: element.delay
          }}
        />
      ))}
    </ParallaxContainer>
  );
};

export default ParallaxBackground; 